import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, type ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { UrlHelperModels } from '@medsurf/flat-models';
import { FeedbackControlService } from '../../internal';

@Injectable({
  providedIn: 'root',
})
export class NavigationControlService {
  #showClose: any;
  #showSearch: any;
  #isPrinting: any;
  
  get isPrinting(): any {
    return this.#isPrinting;
  }
  set showClose(value: any) {
    this.#showClose = value;
  }
  get showClose(): any {
    return this.#showClose;
  }
  set showSearch(value: any) {
    this.#showSearch = value;
  }
  get showSearch(): any {
    return this.#showSearch;
  }

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              private feedbackControlService: FeedbackControlService) {
  }

  static goBack() {
    // if (this.backState) {
    //   this.router.navigate([this.backState.state, this.backState.param]);
    // }
    history.back();
  }

  static getSemanticString(value: any) {
    if (!value) {
      return null;
    }
    return UrlHelperModels.Url.getSemanticString(value);
  }

  async handleError() {
    await this.router.navigate(['404']);
  }

  async goHome() {
    await this.router.navigate(['']);
  }

  goSubject() {
    this.route.paramMap.pipe(
      switchMap(async (params: ParamMap) =>
        await this.router.navigate(['',
          params.get('elearningSlug'),
          params.get('subjectSlug')]))
    );
  }

  async selectPage(id: string) {
    switch (id) {
      case 'quiz-histologie':
        this.route.paramMap.pipe(
          switchMap(async (params: ParamMap) =>
            await this.router.navigate(['quiz-selection', {
              elearningSlug: params.get('elearningSlug'),
              subjectSlug: params.get('subjectSlug'),
              chapterSlug: params.get('chapterSlug')
            }]))
        );
        break;

      default:
        await this.router.navigate([id]);
        break;
    }
  }

  selectLink(event: any) {
    if (event.params.pageSlug === 'feedback') {
      this.feedbackControlService.openFeedbackModal();
    } else {
      const navigation = [event.path];
      this.router.navigate(navigation.concat(Object.values(event.params)));
    }
  }
}